import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Divider } from "antd";
import DatePicker from "react-datepicker";
import Navbar from "../../../Components/Navbar/Navbar";
import Select from "react-select";
import { selectDropdownStyle } from "../../../Helpers/Utils/Common";
import { UseGetRequest } from "../../../Helpers/Hooks/GetApiRequests";
import Footer from "../../../Components/Footer/Footer";

function Ejournal() {
  const [inactive, setInactive] = useState(true);
  const dateToday = new Date().toLocaleDateString("en-CA");
  const [filter, setFilter] = useState({
    date: dateToday,
    branch_id: null,
  });
  const [branchOptions, setBranchOptions] = useState([]);

  useEffect(() => {
    async function fetchAllBranches() {
      setBranchOptions([]);
      const response = await UseGetRequest("branches/get_all_branch", {});
      if (response.data) {
        const temp = response.data.data.map((row) => {
          var info = {};
          info.label = row.name;
          info.value = row.id;
          return info;
        });
        setBranchOptions([{ label: "All", value: null }, ...temp]);
      }
    }

    fetchAllBranches();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"REPORTS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> E-JOURNAL </h1>
          </Col>
        </Row>
        <hr />
        <div className="mb-3" />
        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
        </span>
        <Row className="PO-filters flex flex-row mx-2 my-1">
          <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              name="date_from"
              placeholderText={"Select Date"}
              onChange={(e) => {
                if (e) {
                  setFilter(
                    new Date(e.target.value).toLocaleDateString("en-CA")
                  );
                }
              }}
              value={filter.date}
              fixedHeight
              className="date-filter me-4 form-control py-3"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
          </Col>
          <Col xs={6} lg={2}>
            <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder={"All Branches"}
                    styles={selectDropdownStyle}
                    options={branchOptions}
                    onChange={(e) =>
                      setFilter((prev) => ({ ...prev, branch_id: e.value }))
                    }
                  />
          </Col>
        </Row>
        <div className="mb-2" />
        <div className="report-tab-content">
          
          <Divider/>
          <Row className="d-flex justify-content-center my-5">
            <Col xs={8} md={4} lg={3} className="">
              <button
                className="custom-primary-btn p-4"
                disabled={!filter.branch_id}
              >
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href={`https://paperworld-api.myt-projects.com/public/ejournal/${filter.date}/${filter.branch_id}.txt`}
                >
                  Export to Ejournal
                </a>
              </button>
            </Col>
          </Row>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Ejournal;
